export const themeColor = {
  personal10: "#43ABF4",
  personal30: "#3A98DC",
  personal50: "#4398C3",
  border10: "#E8EBF1",
  border70: "#777777",
  white0: "#ffffff",
  white10: "#f7f7f7",
  white20: "#FAFBFC",
  white50: "#e9e9e9",
  black: "#252525",
};
